import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Assets
import img1 from "../../assets/from1.png";
import img2 from "../../assets/from2.png";

gsap.registerPlugin(ScrollTrigger);

const LensToWall = () => {
  const sectionRef = useRef(null);
  const triggerRef = useRef(null);
  const fromTextRef = useRef(null);
  const toTextRef = useRef(null);
  const secondImgRef = useRef(null);

  useEffect(() => {
    // 1. "FROM THIS" Entrance
    gsap.fromTo(
      fromTextRef.current,
      { opacity: 0, y: 100 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        scrollTrigger: {
          trigger: fromTextRef.current,
          start: "top 80%",
        },
      },
    );

    // 2. The Cinematic Reveal Timeline
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: triggerRef.current,
        start: "top top",
        end: "+=2000", // Length of the scroll effect
        scrub: 1, // Smoothly ties animation to scroll
        pin: true, // Keeps the section fixed while animating
        anticipatePin: 1,
      },
    });

    tl.fromTo(
      toTextRef.current,
      { opacity: 0, scale: 0.8 },
      { opacity: 1, scale: 1, duration: 1 },
    )
      .to(
        toTextRef.current,
        {
          xPercent: -150, // Moves text to the left
          ease: "power2.inOut",
          duration: 2,
        },
        "+=0.5",
      ) // slight pause at center
      .fromTo(
        secondImgRef.current,
        { xPercent: 100, opacity: 0 },
        { xPercent: 0, opacity: 1, ease: "power2.inOut", duration: 2 },
        "<", // Starts at the same time as the text moving left
      );

    return () => {
      ScrollTrigger.getAll().forEach((t) => t.kill());
    };
  }, []);

  return (
    <Container>
      <Section className="from">
        <BigTitle ref={fromTextRef}>From This</BigTitle>
        <ImageWrapper>
          <img src={img1} alt="Original" />
        </ImageWrapper>
      </Section>

      <PinSection ref={triggerRef}>
        <div className="content-wrapper">
          <BigTitle ref={toTextRef} className="to-text">
            To This
          </BigTitle>
          <RevealImage ref={secondImgRef} src={img2} alt="Result" />
        </div>
      </PinSection>

      {/* Spacer to allow scrolling past the pinned section */}
      {/* <div style={{ height: "50vh" }} /> */}
    </Container>
  );
};

export default LensToWall;

// --- Styled Components ---

const Container = styled.div`
  background-color: #0a0804;
  color: #fff;
  overflow-x: hidden;
  margin: 10em 0 2em 0;
`;

const Section = styled.section`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px;
`;

const PinSection = styled.section`
  height: 100vh;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .content-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

const BigTitle = styled.h1`
  font-size: 7vw; // Massive typography
  font-family: "Ams";
  font-weight: 100;
  /* text-transform: uppercase; */
  margin: 0;
  z-index: 2;
  white-space: nowrap;
  padding-top: 2em;
  text-shadow: 0 12px 4px #4e4a4a;
`;

const ImageWrapper = styled.div`
  width: 60%;
  margin-top: 20px;
  img {
    margin-top: 5em;
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
`;

const RevealImage = styled.img`
  position: absolute;
  right: 10%;
  width: auto;
  height: 80vh;
  z-index: 1;
  border-radius: 12px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5);
`;
